export default {"src":"/_next/static/media/dift-medal.fc75c359.svg","height":34,"width":32,"blurWidth":0,"blurHeight":0};